export default {
  title: "Regra tipo 2 - Alocação máxima de um colaborador no rateio indireto",
  subtitle: "Qual o percentual máximo do salário do colaborador que o rateio indireto pode pagar? O restante será overhead CESAR.",
  token: "max_percent_salary_in_apportionment",
  orderBy: "value_a",
  paramsVerify: {
    param: "value_a",
    value: "*",
  },
  convert: {
    param: "value_a",
    method: "collaborator_registration",
  },
  tables: [
    {
      title: "Regra geral",
      type: "general",
      actions: "edit",
      columns: [
        {
          label: "Colaborador",
          key: "value_a",
          placeholder: "Todos",
          value: "*",
          info: "Acrescente * para selecionar todos",
        },
        {
          label: "Alocação máxima",
          key: "value_c",
          type: "percent",
        },
      ],
      data: [],
    },
    {
      type: "exception",
      title: "Exceções",
      actions: "edit_remove",
      columns: [
        {
          label: "Colaborador",
          key: "value_a",
        },
        {
          label: "Alocação máxima",
          key: "value_c",
          type: "percent",
        },
      ],
      data: [],
    },
  ],
  drawer: {
    title: {
      insert_label: "Adicionar Regra",
      update_label: "Editar Regra",
    },
    subtitle: "Alocação máxima de um colaborador no rateio indireto",
    form: [
      {
        label: "Informe o Colaborador:",
        type: "list_collaborator",
        key: "value_a",
        placeholder: "",
        value: "*",
        visible: false,
      },
      {
        label: "Informe a alocação máxima do do colaborador",
        type: "percent",
        info: "",
        key: "value_c",
        value: "",
        visible: true,
      },
    ],
  },
};
